import { EyeInvisibleOutlined, EyeOutlined } from '@ant-design/icons';
import { THEME } from '@common/constants/theme.constant';
import { Icon } from '@common/general-ui/icon/icon.component';
import { IInputV2Props, InputV2 } from '@common/general-ui/input-v2/input-v2.component';
import React, { useCallback, useState } from 'react';
import { css } from 'twin.macro';

export interface IPasswordV2Props<T = string | number, TName = string> extends IInputV2Props<T, TName> {
    showPasswordIcon?: boolean;
}

export const PasswordV2 = ({ showPasswordIcon = true, ...rest }: IPasswordV2Props): JSX.Element => {
    const { readOnly } = rest;
    const [showPassword, setShowPassword] = useState(false);

    const handleShowPasswordClick = useCallback(() => {
        setShowPassword(!showPassword);
    }, [showPassword]);

    const renderSuffix = (): JSX.Element | undefined => {
        if (readOnly && !showPasswordIcon) {
            return undefined;
        }

        return (
            <div onClick={handleShowPasswordClick}>
                {showPassword ? (
                    <Icon icon={EyeOutlined} css={styles.icon} />
                ) : (
                    <Icon icon={EyeInvisibleOutlined} css={styles.icon} />
                )}
            </div>
        );
    };

    return (
        <>
            {/* https://stackoverflow.com/questions/15738259/disabling-chrome-autofill */}
            {rest.autoComplete === 'off' ? <input type="password" name={rest.name} tw="hidden" /> : null}
            <InputV2
                autoComplete="off"
                {...rest}
                css={styles.root}
                suffix={renderSuffix()}
                type={showPassword ? 'text' : 'password'}
            />
        </>
    );
};

const styles = {
    root: css`
        && .ant-input {
            padding-top: 2px;
            vertical-align: inherit;
            font-weight: 300;
        }
        &&.ant-input-affix-wrapper:focus-within {
            outline-color: transparent !important;
            outline-style: none;
            box-shadow: none;
            border-color: ${THEME.TEXT_BLACK};
        }
    `,
    icon: css`
        vertical-align: center;
        cursor: pointer;
    `,
};
